export default {
  '9231ee25b0984ec4a3f91ffbe56786eb': "I haven't picked out enough free gifts yet",
  '66ee61e22d3270ba37dd28b22ea0151d': 'Promotional product detail page - Gift selection',
  b6a29f60129c867d3c91fb196fe1be47: 'Original price',
  e00ec5caafbdeeaea86f898eecf81f5a: 'Please select a product',
  cc743ad271e57939f390074b7a93d072: 'Sold out',
  '4a26e922ec195bf003c5c486f1a011c2': 'Sign a contract for free',
  '116e491a459350c4d6f6b51e7b9d2c49': 'Sure',
  b09069a95d7f2ef659e01a90323ecb84: 'Selection of promotional subscription methods',
  '3f0a50e2ec7f044f2a70e8777718e353': 'Subscribe',
  be747cb7f5901629ce6a0408e6976c54: 'Recommend',
  '3fce0224ae8157036a3ad2223ccdd347':
    'Promotion product details page - SKU Selection drawer - Select the product',
  '897a98f3fb07a2bc17a078d648647e62': 'select ',
  fb431249bf33c4e9bab8360fa8fab53e: ' gifts'
};
